import React, { useState, useEffect, useCallback } from 'react';

const SCHEMES = [
  { id: 'light', title: 'Light' },
  { id: 'dark', title: 'Dark' },
  { id: 'auto', title: 'System' },
];

const SunIcon = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="5" />
    <path d="M12 1v3M12 20v3M4.22 4.22l2.12 2.12M17.66 17.66l2.12 2.12M1 12h3M20 12h3M4.22 19.78l2.12-2.12M17.66 6.34l2.12-2.12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" fill="none" />
  </svg>
);

const MoonIcon = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M21 12.79A9 9 0 1 1 11.21 3a7 7 0 0 0 9.79 9.79z" />
  </svg>
);

const AutoIcon = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="2" />
    <path d="M12 2a10 10 0 0 1 0 20V2z" />
  </svg>
);

const ICON_MAP = { light: SunIcon, dark: MoonIcon, auto: AutoIcon };

function getSystemScheme() {
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

function applyScheme(schemeId) {
  const resolved = schemeId === 'auto' ? getSystemScheme() : schemeId;
  if (resolved === 'dark') {
    document.documentElement.setAttribute('data-scheme', 'dark');
  } else {
    document.documentElement.removeAttribute('data-scheme');
  }
}

export default function SchemeToggle() {
  const [scheme, setScheme] = useState(() => {
    return localStorage.getItem('foodplan-scheme') || 'auto';
  });

  const handleSystemChange = useCallback(() => {
    if (scheme === 'auto') applyScheme('auto');
  }, [scheme]);

  useEffect(() => {
    applyScheme(scheme);
  }, [scheme]);

  useEffect(() => {
    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    mq.addEventListener('change', handleSystemChange);
    return () => mq.removeEventListener('change', handleSystemChange);
  }, [handleSystemChange]);

  const handleSwitch = (id) => {
    setScheme(id);
    localStorage.setItem('foodplan-scheme', id);
  };

  return (
    <div className="scheme-toggle">
      {SCHEMES.map(({ id, title }) => {
        const Icon = ICON_MAP[id];
        return (
          <button
            key={id}
            className={`scheme-btn${scheme === id ? ' active' : ''}`}
            onClick={() => handleSwitch(id)}
            aria-label={title}
            title={title}
          >
            <Icon />
          </button>
        );
      })}
    </div>
  );
}
